import { select } from "redux-saga/effects";
import { createSelector } from "reselect";
import "../../../../../../../state/actions.js";
import { NEW_PRESCRIPTION, NEW_PRESCRIPTION_AND_UPLOAD } from "../../../../../../../state/constants.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import { getPrescriptionType, getIsPrescriptionFormStepValid } from "../../../../../../state/configurator/selectors.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
import { PrescriptionFormStepContainer } from "../../../../../../../../steps/PrescriptionFormStep/steps/PrescriptionFormStep/PrescriptionFormStepContainer.js";
const prescriptionFormStepBase = {
  *onNext() {
    const isValid = yield select(getIsPrescriptionFormStepValid);
    if (!isValid) {
      return new Error(`Need valid prescription data for unknown customer`);
    }
  },
  view: PrescriptionFormStepContainer,
  stepStatus: createSelector(
    getPrescriptionType,
    (prescriptionType) => prescriptionType === NEW_PRESCRIPTION || prescriptionType === NEW_PRESCRIPTION_AND_UPLOAD ? "sub-step" : "hidden"
  )
};
export {
  prescriptionFormStepBase
};
//# sourceMappingURL=prescription-form.js.map
